import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import FormatIcon from '@bibliocommons/format-icon';

import './FormatIndicator.scss';

class FormatIndicator extends React.PureComponent {
  render() {
    return (
      <span className="cp-format-indicator" data-test-id="format-indicator">
        <FormatIcon aria-hidden className="icon-format" format={this.props.format} />
        <FormattedMessage id={`FORMAT.${this.props.format.toLowerCase()}`} />
      </span>
    );
  }
}

FormatIndicator.propTypes = {
  format: PropTypes.string
};

export default FormatIndicator;
